import { render } from "./AllocatedBackorderHistoryContainer.vue?vue&type=template&id=66778b77&scoped=true"
import script from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js"
export * from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js"

import "./AllocatedBackorderHistoryContainer.vue?vue&type=style&index=0&id=66778b77&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66778b77"]])

export default __exports__